(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/terms-integrity-react/assets/react/shared-components/top-menu.js') >= 0) return;  svs.modules.push('/modules/terms-integrity-react/assets/react/shared-components/top-menu.js');

'use strict';

const _svs$termsIntegrity$c = svs.termsIntegrity.constants.route,
  TIR_HOME = _svs$termsIntegrity$c.TIR_HOME,
  TIR_TERMS = _svs$termsIntegrity$c.TIR_TERMS,
  TIR_INTEGRITY = _svs$termsIntegrity$c.TIR_INTEGRITY,
  TIR_RULES = _svs$termsIntegrity$c.TIR_RULES;
const _svs$ui$ReactItemsMen = svs.ui.ReactItemsMenu,
  ItemsMenu = _svs$ui$ReactItemsMen.ItemsMenu,
  LinkItem = _svs$ui$ReactItemsMen.LinkItem;
const Link = svs.app.ReactRouter.Link;
const _ReactRouterDOM = ReactRouterDOM,
  useLocation = _ReactRouterDOM.useLocation;
const TopMenu = () => {
  const location = useLocation();
  const branding = svs.core.config.data.svsconfig.site === 'momang' ? 'momang' : 'sport';
  return React.createElement(ItemsMenu, {
    branding: branding,
    centered: true,
    className: "loginItemsMenu"
  }, React.createElement(LinkItem, {
    Component: Link,
    label: "Personuppgifter",
    selected: location.pathname === TIR_INTEGRITY,
    to: TIR_INTEGRITY
  }), React.createElement(LinkItem, {
    Component: Link,
    label: "Villkor",
    selected: location.pathname === TIR_TERMS || location.pathname === TIR_HOME,
    to: TIR_TERMS
  }), React.createElement(LinkItem, {
    Component: Link,
    label: "Spelregler",
    selected: location.pathname === TIR_RULES,
    to: TIR_RULES
  }));
};
svs.termsIntegrity.sharedComponents.TopMenu = TopMenu;

 })(window);